/**
 * Super-Admin Whitelist
 *
 * The email addresses that can see internal developer surfaces (e.g. the
 * reported-errors page). The one copy: the web app (hooks/useIsSuperAdmin.ts)
 * and the API (utils/is-admin-request.ts, routes/custom/error-reports-routes.ts)
 * both import it from @aiga/app-config/security, so visibility and
 * authorization can't diverge.
 *
 * Membership rules:
 *   - aigeniustesting@gmail.com (explicit, the QA/testing account)
 *   - any address on @aigeniusautomations.com
 *   - any address on @aigeniusconsulting.com
 */
export const SUPER_ADMIN_EXPLICIT_EMAILS = [
    'aigeniustesting@gmail.com',
];
export const SUPER_ADMIN_DOMAINS = [
    'aigeniusautomations.com',
    'aigeniusconsulting.com',
];
export function isSuperAdminEmail(email) {
    if (!email)
        return false;
    const normalized = email.trim().toLowerCase();
    if (!normalized)
        return false;
    if (SUPER_ADMIN_EXPLICIT_EMAILS.includes(normalized))
        return true;
    const at = normalized.lastIndexOf('@');
    if (at < 0)
        return false;
    const domain = normalized.slice(at + 1);
    return SUPER_ADMIN_DOMAINS.includes(domain);
}
/**
 * AIG staff: a whitelisted email AND an admin role (role and email, the same pair the
 * AI-lab gate checks). AIG staff hold every key, the exact-grant-only ones included
 * (docs/SECURITY.md "AIG staff hold every key"). A client Super Admin (role, no email)
 * and an AIG Broker (email, no admin role) are not AIG staff.
 */
export function isAigStaff(user) {
    return user.isAdmin && isSuperAdminEmail(user.email);
}
//# sourceMappingURL=super-admin-whitelist.js.map